"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.Pipe = exports.pipeGaps = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias PipeRow.pipeGaps
 */
var pipeGaps = {
  /** sm */
  SM: "sm",

  /** md */
  MD: "md"
};
/**
 * @class PipeRow
 * @desc Simple row that puts pipes between its items. Usually used for side-by-side links.
 *
 * @param {string} [className]
 *     CSS classes to be set on the root element.
 * @property {string} [data-id]
 *     To define the base "data-id" value for the top-level HTML container.
 * @property {PipeRow.pipeGaps} [gap=MD]
 *     Gap between the items and the pipe
 */

/**
 * @class Pipe
 * @memberof PipeRow
 * @desc Render the pipe
 *
 * @property {PipeRow.pipeGaps} [gap=MD]
 *     Gap between the pipe and other items.
 */

exports.pipeGaps = pipeGaps;

var Pipe = function Pipe(_ref) {
  var _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? "md" : _ref$gap;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("pipe", "pipe--".concat(gap))
  });
};

exports.Pipe = Pipe;

var PipeRow = function PipeRow(_ref2) {
  var _context;

  var children = _ref2.children,
      className = _ref2.className,
      dataId = _ref2["data-id"],
      gap = _ref2.gap;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("pipe-row", className),
    "data-id": dataId
  }, (0, _map.default)(_context = _react.default.Children).call(_context, children, function (child, index) {
    return index > 0 ? [/*#__PURE__*/_react.default.createElement(Pipe, {
      key: "pipe-".concat(index),
      gap: gap
    }), child] : child;
  }));
};

PipeRow.propTypes = {
  gap: _propTypes.default.oneOf((0, _values.default)(pipeGaps))
};
PipeRow.defaultProps = {
  gap: pipeGaps.MD
};
var _default = PipeRow;
exports.default = _default;